import { RouterProvider, createRouter, createRootRoute, Outlet } from '@tanstack/react-router';
import { Elements } from '@stripe/react-stripe-js';
import { QueryClientProvider } from '@tanstack/react-query';

import { createPublicRouteTree } from './publicRoutes';
import { createPrivateRouteTree } from './privateRoutes';
import { usersApi, teachurKeys, User, queryClient } from '@teachur/http-client';
import { AppUpdateModal } from '@new/features/announcement/components/AppUpdateModal/AppUpdateModal';
import { loadStripeSafely } from '@new/lib/stripe';

export interface RouterContext {
  getUser: () => Promise<User>;
}

const stripePromise = loadStripeSafely(import.meta.env.VITE_STRIPE_KEY);

const rootRoute = createRootRoute({
  component: () => (
    <Elements stripe={stripePromise}>
      <Outlet />
    </Elements>
  ),
});

const routeTree = rootRoute.addChildren([
  createPublicRouteTree(rootRoute),
  createPrivateRouteTree(rootRoute),
]);

const router = createRouter({
  routeTree,
  context: {
    getUser: async () => {
      try {
        const user = await queryClient.fetchQuery({
          queryKey: teachurKeys.users.currentUser(),
          queryFn: async () => {
            const response = await usersApi.getCurrentUser();
            return response.data;
          },
        });
        return user;
      } catch (error) {
        console.error('Failed to fetch current user:', error);
        return false;
      }
    },
  },
});

export const Routes = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} defaultPreload="intent" />
      <AppUpdateModal />
    </QueryClientProvider>
  );
};
